module.exports = __webpack_public_path__ + "img/quantum-computer.4f1c1198.svg";